import { render, staticRenderFns } from "./StarboardFlowRateChart.vue?vue&type=template&id=643c4c23"
import script from "./StarboardFlowRateChart.vue?vue&type=script&lang=js"
export * from "./StarboardFlowRateChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports